export default "__VITE_ASSET__BdK3bhVj__"